<template>
  <el-dialog
    title="基本工资编辑"
    :visible.sync="state"
    width="30%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <tz-form
      width="110px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="user"
      @submit="submitFn"
    ></tz-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
import { memberList } from '@/api/employeesalary'
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    user: Object,
    roles: Array
  },

  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '姓名',
          field: 'personId',
          type: 'select',
          payload: [],
          rules: [{ required: true, message: '姓名必填', trigger: 'blur' }]
        },
        {
          label: '身份证号',
          field: 'cardNo',
          type: 'text',
          rules: [
            { required: true, message: '身份证号必填', trigger: 'blur' }
            // { min: 1, max: 5, message: '简写长度为1到5', trigger: 'blur' }
          ]
        },
        {
          label: '基本工资',
          field: 'basePay',
          type: 'text',
          unit: '元',
          rules: [{ required: true, message: '基本工资必填', trigger: 'blur' }]
        },
        // {
        //   label: '年限工资',
        //   field: 'lifePay',
        //   type: 'text',
        //   unit: '元',
        //   rules: [{ required: true, message: '年限工资必填', trigger: 'blur' }]
        // },
        // {
        //   label: '持证工资',
        //   field: 'certPay',
        //   type: 'text',
        //   unit: '元',
        //   rules: [{ required: true, message: '持证工资必填', trigger: 'blur' }]
        // },
        {
          label: '职称工资',
          field: 'titlePay',
          type: 'text',
          unit: '元',
          rules: [{ required: true, message: '职称工资必填', trigger: 'blur' }]
        },
        {
          label: '职位工资',
          field: 'postPay',
          type: 'text',
          unit: '元',
          rules: [{ required: true, message: '职位工资必填', trigger: 'blur' }]
        },
        {
          label: '是否参与绩效',
          field: 'isPerformanceCalc',
          type: 'select',
          payload: [{ value: 1, label: '参与' }, { value: 2, label: '不参与' }]
        }
      ],

      formBtns: [
        {
          content: '更新',
          width: '185px',
          type: 'primary'
          // },
          // {
          //   content: '重置',
          //   type: ''
        }
      ]
    }
  },
  created() {
    this.getMemberList()
  },
  methods: {
    // 查看所有员工
    getMemberList() {
      let params = {
        personName: this.personName
      }
      memberList(params).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.formConfig[0].payload = res.data.map((el) => {
              return {
                value: el.personId,
                label: el.personName
              }
            })
          }
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
    submitFn(formData) {
      let membersArr = this.formConfig[0].payload
      let memberName = membersArr.find((el) => el.value === formData.personId)
      if (memberName) formData.personName = memberName.label
      this.$emit('confirm', formData)
      console.log('更新数据处理', formData)
    }
  }
}
</script>

<style></style>
